import React from 'react';
import { fieldLabelAttCadastral } from '@utils';
import { SectionTable } from './SectionTable';

export const ConferenciaForm = ({ changedValues }) => {
  const tipos = {
    Pessoais: Object.keys(changedValues).filter(
      (key) => fieldLabelAttCadastral[key]?.tipo === 'Pessoais'
    ),
    Contato: Object.keys(changedValues).filter(
      (key) => fieldLabelAttCadastral[key]?.tipo === 'Contato'
    ),
    Residências: Object.keys(changedValues).filter(
      (key) => fieldLabelAttCadastral[key]?.tipo === 'Residências'
    ),
  };

  return (
    <>
      <div className="d-flex mt-15 justify-content-start">
        <div className="d-flex col-8 align-items-center">
          <p className="text-muted ts-18 fw-bold">
            Por favor, revise e confirme as informações atualizadas abaixo.
          </p>
        </div>
      </div>
      <div className="col-12">
        <div
          style={{
            border: '1px solid #ccc',
            padding: '16px',
            borderRadius: '8px',
            marginTop: '20px',
          }}
        >
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
            }}
          >
            <tbody>
              {Object.keys(changedValues).length === 0 && (
                <tr>
                  <td
                    style={{
                      fontWeight: 'bold',
                      paddingRight: '8px',
                      color: '#555',
                    }}
                  >
                    Não há alterações a serem listadas
                  </td>
                </tr>
              )}
              {Object.entries(tipos).map(([title, keys]) =>
                SectionTable({ title, keys, changedValues })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
